import { render, staticRenderFns } from "./delTag.vue?vue&type=template&id=372d52b8"
import script from "./delTag.vue?vue&type=script&lang=js"
export * from "./delTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports